/**
 * EB 商户端 API 根路径
 * 对应 view/mer/src/libs/settingMer.js：https = VUE_APP_BASE_API + '/mer'
 *
 * - 开发：VITE_APP_BASE_API=/api → /api/mer（Vite proxy 去掉 /api → 后端 /mer）
 * - 生产：可为 /api/mer 或 /api（自动补 /mer）
 */
export function getCrmebMerchantApiBase(): string {
  const base = String(import.meta.env.VITE_APP_BASE_API || '/api').replace(/\/$/, '');
  return base.endsWith('/mer') ? base : `${base}/mer`;
}
